import {
  UTM_DEFAULT_SOURCE,
  UTM_DEFAULT_MEDIUM,
  UTM_DEFAULT_CAMPAIGN,
  urlSinUtmsPrincipales,
  resolveUtmSourceAndMedium,
  readSessionString,
} from "../utils/utmParams";

export { UTM_DEFAULT_SOURCE, UTM_DEFAULT_MEDIUM, UTM_DEFAULT_CAMPAIGN, urlSinUtmsPrincipales };

function pickFromUrlOrSession(key, search) {
  const s = search !== undefined ? search : typeof window !== "undefined" ? window.location.search || "" : "";
  try {
    const fromUrl = new URLSearchParams(s).get(key);
    if (fromUrl != null && String(fromUrl).trim() !== "") {
      return String(fromUrl).trim();
    }
  } catch {
    // ignore
  }
  return readSessionString(key);
}

export function getUtmParams() {
  if (typeof window === "undefined") {
    return {
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_term: null,
    };
  }

  const search = window.location.search || "";
  const { utm_source, utm_medium } = resolveUtmSourceAndMedium(search);

  const utm_campaign = pickFromUrlOrSession("utm_campaign", search);
  const utm_term = pickFromUrlOrSession("utm_term", search);

  return {
    utm_source: utm_source || UTM_DEFAULT_SOURCE,
    utm_medium: utm_medium || UTM_DEFAULT_MEDIUM,
    utm_campaign: utm_campaign || UTM_DEFAULT_CAMPAIGN,
    utm_term: utm_term || null,
  };
}

export function saveUtmParams() {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") return;

  let search = "";
  try {
    search = window.location.search || "";
  } catch {
    return;
  }

  try {
    if (urlSinUtmsPrincipales(search)) {
      sessionStorage.setItem("utm_source", UTM_DEFAULT_SOURCE);
      sessionStorage.setItem("utm_medium", UTM_DEFAULT_MEDIUM);
      sessionStorage.setItem("utm_campaign", UTM_DEFAULT_CAMPAIGN);
      sessionStorage.removeItem("utm_term");
      return;
    }

    const q = new URLSearchParams(search);
    ["utm_source", "utm_medium", "utm_campaign", "utm_term"].forEach((key) => {
      const v = q.get(key);
      if (v != null && String(v).trim() !== "") {
        sessionStorage.setItem(key, String(v).trim());
      }
    });
  } catch {
    // ignore
  }
}

/**
 * URL actual con UTMs coherentes: defaults si no hay principales en query;
 * si hay campaña en query, no pisa; completa source/medium faltantes desde sesión o defaults.
 */
export function getCurrentUrlWithUtmDefaults() {
  if (typeof window === "undefined") return "";
  let u;
  try {
    u = new URL(window.location.href);
  } catch {
    return window.location.href;
  }

  const params = getUtmParams();
  const search = u.search || "";

  if (urlSinUtmsPrincipales(search)) {
    u.searchParams.set("utm_source", params.utm_source);
    u.searchParams.set("utm_medium", params.utm_medium);
    if (params.utm_campaign) u.searchParams.set("utm_campaign", params.utm_campaign);
    else u.searchParams.delete("utm_campaign");
    if (params.utm_term) u.searchParams.set("utm_term", params.utm_term);
    else u.searchParams.delete("utm_term");
    return u.toString();
  }

  const hasVal = (key) => {
    const v = u.searchParams.get(key);
    return v != null && String(v).trim() !== "";
  };
  if (!hasVal("utm_source")) u.searchParams.set("utm_source", params.utm_source);
  if (!hasVal("utm_medium")) u.searchParams.set("utm_medium", params.utm_medium);
  if (!hasVal("utm_campaign")) u.searchParams.set("utm_campaign", params.utm_campaign);
  return u.toString();
}

export function buildUtmQueryString() {
  const { utm_source, utm_medium, utm_campaign } = getUtmParams();
  return `?utm_source=${encodeURIComponent(utm_source)}&utm_medium=${encodeURIComponent(
    utm_medium
  )}&utm_campaign=${encodeURIComponent(utm_campaign)}`;
}
